module.exports = __webpack_public_path__ + "static/media/iconUk.117600e2.svg";